import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Chip, Grid, Link, Stack, Tab } from '@mui/material';
import { DataGridProProps, GridActionsCellItem, GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import {
  useLazyGetSubjectCRFDetailsQuery,
  useLazyGetVisitCRFOIDsQuery,
  useSelectCRFDataByIDMutation
} from 'src/services/SubjectTrackingDetails';
import { openCRFModel, setSelectedCRFOID, setSelectedCRFRow } from 'src/store/CrfFormsAction';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetAuditQuery } from 'src/services/Queries';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { clearSubjectInfo } from 'src/store/SelectedSubject';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import staticData from '../../../../resources/static.json';
import AuditTrailContent from './AuditTrailLayout';
import CRFBasePopup from './CRFBasePopup';
import { DataTable } from '@pihealth/common-ui-library';
import { useTrailNotebookCRF } from '../../PatientTrialNoteBook/useTrailNotebookCRF';

const CRFSTab: React.FC<any> = ({ parent_id, filteredVisit, subject_id, selectedCRF }) => {
  const isLoaderInitiated: any = useAppSelector(state => state.loader.isProgress);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const isOpenCRFModel = useAppSelector(state => state.CRFForms.isOpenCRFModel);
  const { checkPermission } = usePermissionWrapper();

  const [isUpdate, setisUpdate] = useState(false);

  const { userPreferedDateFormat } = usePreferedDateFormat();
  const getTreeDataPath: DataGridProProps['getTreeDataPath'] = row => row.hierarchy;
  const groupingColDef: DataGridProProps['groupingColDef'] = {
    headerName: 'Event Number',
    minWidth: 100,
    flex: 1
  };

  const dispatch = useAppDispatch();
  const setSelectedRowData = (e: any) => {
    dispatch(setSelectedCRFRow(e));
  };

  const [selectedVisit, setselectedVisit] = useState<any>(null);

  const {
    getVisitSpecificCRFs,
    getVisitSpecificCRFsData,
    getVisitSpecificCRFsIsError,
    getVisitSpecificCRFsIsSuccess,
    getVisitSpecificCRFsIsLoading,
    getVisitSpecificCRFsError
  } = useTrailNotebookCRF();
  useEffect(() => {
    dispatch(showLoader());
    if (getVisitSpecificCRFsData && !getVisitSpecificCRFsIsLoading && getVisitSpecificCRFsIsSuccess && filteredVisit) {
      const mockArr: any = [];
      const duplicateArrCheck: any = [];
      getVisitSpecificCRFsData?.map((obj: any) => {
        if (!duplicateArrCheck.includes(obj.OID)) {
          mockArr.push({ OID: obj.visit_crf.OID, custom_name: obj.visit_crf.custom_name });
          duplicateArrCheck.push({ OID: obj.visit_crf.OID });
        }
      });
      setvisitCRFOIDs(mockArr);
      setselectedFormOID(mockArr[0].OID);
    } else if (!getVisitSpecificCRFsIsLoading && getVisitSpecificCRFsIsError && getVisitSpecificCRFsError) {
      setvisitCRFOIDs([]);
      setselectedVisit(null);
      setcrfVisitList([]);
      setcrfFormMetaData(null);
    }
    dispatch(hideLoader());
  }, [
    getVisitSpecificCRFsData,
    getVisitSpecificCRFsIsError,
    getVisitSpecificCRFsIsSuccess,
    getVisitSpecificCRFsIsLoading,
    getVisitSpecificCRFsError,
    filteredVisit
  ]);
  const [
    getVisitsAndCRFOIDs,
    {
      isLoading: studyCRFsIsLoading,
      isSuccess: studyCRFsIsSuccess,
      data: getVisitsAndCRFOIDsData,
      isError: studyCRFsIsError,
      error: studyCRFsError
    }
  ] = useLazyGetVisitCRFOIDsQuery();

  const [
    getPatientsDetails,
    {
      data: getPatientsDetailsData,
      isError: getPatientsDetailsIsError,
      isLoading: getPatientsDetailsIsLoading,
      error: getPatientsDetailsError
    }
  ] = useLazyGetSubjectCRFDetailsQuery();

  const [
    selectCRFDataByID,
    {
      data: selectCRFDataByIDData,
      isLoading: selectCRFDataByIDIsLoading,
      isSuccess: selectCRFDataByIDIsSuccess,
      isError: selectCRFDataByIDIsError
    }
  ] = useSelectCRFDataByIDMutation();

  useEffect(() => {
    if (!selectedCRF) {
      getVisitsAndCRFOIDs({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
    if (parent_id && selectedFormOID) {
      getPatientsDetails({
        OID: selectedFormOID,
        parent_id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  }, [parent_id]);

  useEffect(() => {
    if (studyCRFsIsLoading || getPatientsDetailsIsLoading || getVisitSpecificCRFsIsLoading) {
      if (!isLoaderInitiated) {
        dispatch(showLoader());
      }
    } else {
      dispatch(hideLoader());
    }
  }, [studyCRFsIsLoading, getPatientsDetailsIsLoading, getVisitSpecificCRFsIsLoading]);

  useEffect(() => {
    let errorData: any;
    if (studyCRFsIsError || selectCRFDataByIDIsError) {
      errorData = studyCRFsError || selectCRFDataByIDIsError;
    }
    // if (getPatientsDetailsIsError) {
    //   errorData = getPatientsDetailsError;
    // }
    if (errorData?.status == 403) {
      dispatch(
        setMessage({
          msgDetails: `${errorData?.status} : Forbbiden Access`,
          severity: 'error'
        })
      );
    } else if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
      dispatch(
        setMessage({
          msgDetails: `${errorData?.status} : Internal Server Error`,
          severity: 'error'
        })
      );
    }
  }, [studyCRFsIsError, selectCRFDataByIDIsError]);

  useEffect(() => {
    let errorData: any;
    if (getPatientsDetailsIsError) {
      errorData = getPatientsDetailsError;
    }
    if (studyCRFsIsSuccess && errorData?.status == 403) {
      dispatch(
        setMessage({
          msgDetails: `${errorData?.status} : Forbbiden Access`,
          severity: 'error'
        })
      );
    } else if (
      (studyCRFsIsSuccess && errorData?.status == 500) ||
      errorData?.status == 502 ||
      errorData?.status == 503
    ) {
      dispatch(
        setMessage({
          msgDetails: `${errorData?.status} : Internal Server Error`,
          severity: 'error'
        })
      );
    }
  }, [getPatientsDetailsIsError]);

  const [visitCRFOIDs, setvisitCRFOIDs] = useState<any>([]);
  const [selectedFormOID, setselectedFormOID] = useState<any>(selectedCRF);
  const [crfVisitList, setcrfVisitList] = useState<any>([]);
  const [crfFormMetaData, setcrfFormMetaData] = useState<any>(null);
  const [crfForomColumns, setcrfForomColumns] = useState([]);

  const handleChangeOIDTabs = (_: any, newValue: any) => {
    dispatch(clearSubjectInfo());
    setselectedFormOID(newValue);
  };

  useEffect(() => {
    dispatch(setSelectedCRFOID(selectedFormOID));
  }, [selectedFormOID]);
  const updateVisitCRFOIDs = (visitCRFData: any) => {
    const mockArr: any = [];
    const duplicateArrCheck: any = [];
    visitCRFData?.map((obj: any) => {
      if (!duplicateArrCheck.includes(obj.OID)) {
        mockArr.push(obj);
        duplicateArrCheck.push(obj.OID);
      }
    });
    setvisitCRFOIDs(mockArr);
    setselectedFormOID(mockArr[0].OID);
  };
  useEffect(() => {
    if (getVisitsAndCRFOIDsData) {
      updateVisitCRFOIDs(getVisitsAndCRFOIDsData);
    }
  }, [getVisitsAndCRFOIDsData]);

  useEffect(() => {
    if (visitCRFOIDs.length > 0 && selectedFormOID === '') {
      setselectedFormOID(visitCRFOIDs[0].OID);
    }
  }, [visitCRFOIDs]);

  useEffect(() => {
    if (!isUpdate && selectedFormOID) {
      getPatientsDetails({
        OID: selectedFormOID,
        parent_id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  }, [selectedFormOID, isUpdate, isOpenCRFModel]);

  const bindRowData = (patientsDetailsData: any) => {
    if (patientsDetailsData.length > 0) {
      setcrfFormMetaData(patientsDetailsData[0].visit_crf);
    } else {
      setcrfFormMetaData(null);
    }
    const rows: any = [];
    const addedRow: any = [];
    const dataIds: any = [];
    let filteredPatientDetailsData = patientsDetailsData;
    if (filteredVisit.key != 'All') {
      filteredPatientDetailsData = patientsDetailsData.filter((item: any) =>
        item?.unscheduled_visit !== null
          ? item?.unscheduled_visit == filteredVisit.key
          : item.study_visit.protocol_visit_name == filteredVisit.key
      );
    }

    filteredPatientDetailsData?.map((visit: any) => {
      if (visit?.crf_data?.length > 0) {
        visit.crf_data?.map(async (data: any) => {
          if (!dataIds.includes(data.result.id)) {
            dataIds.push(data.result.id);
            const renderingData = data.result;
            const formData = visit.visit_crf.meta.sections.flatMap((section: any) =>
              section.rows.flatMap((row: any) => row.fields)
            );
            let tempdata = {};
            formData?.map((field: any) => {
              if (
                field?.cmp == 'checkbox' &&
                field?.data_dictionary_values &&
                field?.data_dictionary_values.length > 0
              ) {
                if (renderingData[field.key] != null) {
                  const valUesKeys = Object.keys(renderingData[field.key]);
                  const checkBoxValues: any = [];
                  if (valUesKeys?.length) {
                    valUesKeys?.map((item: any) => {
                      for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                        if (item == field?.data_dictionary_values[i].code_list_value_code) {
                          checkBoxValues.push(field?.data_dictionary_values[i].code_list_value);
                          break;
                        }
                      }
                    });
                  }
                  tempdata = { ...tempdata, [field.key]: checkBoxValues.toString() };
                }
              } else if (
                field?.cmp == 'select' &&
                field?.data_dictionary_values &&
                field?.data_dictionary_values.length > 0
              ) {
                if (field?.multiple && renderingData[field.key] != null) {
                  const multipleValueData = renderingData[field.key].key;
                  const ddmValues: any = [];
                  if (multipleValueData?.length) {
                    multipleValueData?.map((item: any) => {
                      for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                        if (
                          item?.value == field?.data_dictionary_values[i].code_list_value_code ||
                          item?.code_list_value_code == field?.data_dictionary_values[i].code_list_value_code
                        ) {
                          ddmValues.push(field?.data_dictionary_values[i].code_list_value);
                          break;
                        }
                      }
                    });
                  }
                  tempdata = { ...tempdata, [field.key]: ddmValues.toString() };
                } else {
                  if (renderingData[field.key] != null) {
                    tempdata = { ...tempdata, [field.key]: renderingData[field.key].label };
                  }
                }
              } else if (
                field?.cmp == 'radio' &&
                field?.data_dictionary_values &&
                field?.data_dictionary_values.length > 0
              ) {
                for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                  if (renderingData[field.key] == field?.data_dictionary_values[i].code_list_value_code) {
                    tempdata = { ...tempdata, [field.key]: field?.data_dictionary_values[i].code_list_value };
                    break;
                  }
                }
              } else if (field?.cmp == 'date' && field?.type == 'date_time' && renderingData[field.key] != null) {
                tempdata = {
                  ...tempdata,
                  [field.key]: moment(renderingData[field.key]).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)
                };
              } else if (field?.cmp == 'date' && field?.type == 'date' && renderingData[field.key] != null) {
                tempdata = {
                  ...tempdata,
                  [field.key]: moment(renderingData[field.key]).format(`${userPreferedDateFormat.toUpperCase()}`)
                };
              } else if (field?.cmp == 'time' && renderingData[field.key] != null) {
                tempdata = {
                  ...tempdata,
                  [field.key]: renderingData[field.key]
                };
              }
            });
            if (data.linked_crfs_data.length > 0) {
              const associatedCRFsData: any = [];
              data?.linked_crfs_data?.map(async (eventData: any) => {
                if (eventData?.bookmark_key_value && eventData?.bookmark_key) {
                  if (eventData?.bookmark_cmp?.cmp == 'date') {
                    if (eventData?.bookmark_cmp?.type == 'date_time') {
                      associatedCRFsData.push(
                        moment(new Date(eventData.bookmark_key_value)).format(
                          `${userPreferedDateFormat.toUpperCase()} h:mm A`
                        )
                      );
                    } else if (
                      eventData?.bookmark_cmp?.cmp == 'date' &&
                      eventData?.bookmark_cmp?.allow_partial == true &&
                      typeof eventData.bookmark_key_value == 'object'
                    ) {
                      const day = eventData.bookmark_key_value?.allow_partial_day;
                      const month = eventData.bookmark_key_value?.allow_partial_month;
                      const year = eventData.bookmark_key_value?.allow_partial_year;
                      let partialDate: any;
                      if (day && month && year) {
                        const tempDate = userPreferedDateFormat.toUpperCase().replace('DD', day).replace('YYYY', year);
                        if (userPreferedDateFormat.toUpperCase().includes('MMM')) {
                          partialDate = tempDate.replace('MMM', month);
                        } else {
                          partialDate = tempDate.replace('MM', month);
                        }
                        associatedCRFsData.push(partialDate);
                      }
                    } else {
                      associatedCRFsData.push(
                        moment(eventData.bookmark_key_value).format(`${userPreferedDateFormat.toUpperCase()}`)
                      );
                    }
                  } else if (eventData?.bookmark_cmp?.cmp == 'time') {
                    associatedCRFsData.push(eventData.bookmark_key_value);
                  } else if (
                    eventData?.bookmark_cmp?.cmp == 'select' &&
                    eventData?.bookmark_cmp?.multiple &&
                    typeof eventData.bookmark_key_value === 'object' &&
                    'key' in eventData.bookmark_key_value
                  ) {
                    const bookMarkValues = eventData?.bookmark_key_value?.key?.map((value: any) => value.label);
                    associatedCRFsData.push(bookMarkValues.toString());
                  } else if (
                    eventData?.bookmark_cmp?.cmp == 'select' &&
                    typeof eventData.bookmark_key_value === 'object'
                  ) {
                    associatedCRFsData.push(eventData.bookmark_key_value?.label);
                  } else if (eventData?.bookmark_cmp?.cmp == 'checkbox') {
                    let rawData: any = eventData.bookmark_key_value;
                    if (Array.isArray(rawData)) {
                      rawData = rawData.reduce((a, v) => ({ ...a, [v]: true }), {});
                    }
                    const valUesKeys = Object.keys(rawData);
                    const checkBoxValues: any = [];
                    valUesKeys?.map((item: any) => {
                      if (rawData[item]) {
                        for (let i = 0; i < eventData.bookmark_cmp.data_dictionary_values.length; i++) {
                          if (item == eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value_code) {
                            checkBoxValues.push(eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value);
                            break;
                          }
                        }
                      }
                    });
                    associatedCRFsData.push(checkBoxValues.toString());
                  } else if (eventData?.bookmark_cmp?.cmp == 'radio') {
                    const rawData: any = eventData.bookmark_key_value;
                    let returnVal: any = '';
                    if (rawData) {
                      for (let i = 0; i < eventData.bookmark_cmp.data_dictionary_values.length; i++) {
                        if (rawData == eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value_code) {
                          returnVal = `${eventData.bookmark_cmp?.title}-${eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value}`;
                          break;
                        }
                      }
                    }
                    associatedCRFsData.push(returnVal);
                  } else {
                    associatedCRFsData.push(eventData.bookmark_key_value.toString());
                  }
                } else {
                  associatedCRFsData.push(
                    `${eventData.event_number} (${moment(new Date(eventData.date_of_entry)).format(
                      `${userPreferedDateFormat.toUpperCase()}`
                    )})`
                  );
                }
              });
              tempdata = { ...tempdata, associated_crfs: associatedCRFsData };
            } else {
              tempdata = { ...tempdata, associated_crfs: null };
            }
            // const resultData = getCodelistValueFormData(visit.visit_crf.meta, data);
            data = { ...data.result, ...tempdata };
            rows.push({
              hierarchy: [
                `${
                  visit?.unscheduled_visit !== null ? visit?.unscheduled_visit : visit.study_visit.protocol_visit_name
                }${
                  visit.study_visit.visit_date
                    ? `- ${moment(visit.study_visit?.visit_date).format(userPreferedDateFormat.toUpperCase())}`
                    : ''
                }`,
                data.event_number
              ],
              ...data,
              id: data.event_uuid,
              nativeCRFId: data?.id
            });
          }
        });
      } else {
        if (!addedRow.includes(visit.study_visit.protocol_visit_name)) {
          addedRow.push(
            visit?.unscheduled_visit !== null ? visit?.unscheduled_visit : visit.study_visit.protocol_visit_name
          );
          rows.push({
            hierarchy: [
              `${visit?.unscheduled_visit !== null ? visit?.unscheduled_visit : visit.study_visit.protocol_visit_name}${
                visit.study_visit.visit_date
                  ? `- ${moment(visit.study_visit?.visit_date).format(userPreferedDateFormat.toUpperCase())}`
                  : ''
              }`
            ],
            id: visit?.visit_appointment?.appointment_id
          });
        }
      }
    });
    setcrfVisitList(rows);
  };

  useEffect(() => {
    if (selectCRFDataByIDIsLoading && !selectCRFDataByIDIsSuccess) {
      if (!isLoaderInitiated) {
        dispatch(showLoader());
      }
    } else {
      dispatch(hideLoader());
    }
  }, [selectCRFDataByIDIsLoading]);

  useEffect(() => {
    if (!selectCRFDataByIDIsLoading && selectCRFDataByIDIsSuccess && selectCRFDataByIDData) {
      setcrfFormMetaData(selectCRFDataByIDData?.[0]?.form_data);
    }
  }, [selectCRFDataByIDIsLoading, selectCRFDataByIDIsSuccess, selectCRFDataByIDData]);

  const [editRowData, seteditRowData] = useState<any>(null);
  const [rowData, setRowData] = useState<any>({});
  useEffect(() => {
    if (getPatientsDetailsData) {
      bindRowData(getPatientsDetailsData);
    }
    if (getPatientsDetailsData && editRowData) {
      // const findVisit = getPatientsDetailsData.find((item: any) => item.study_visit.id == editRowData.visit_id);   // will remove this once unscheduled story is completed
      const findVisit = getPatientsDetailsData?.find((item: any) =>
        item?.crf_data?.find((ele: any) => ele?.result?.event_uuid === editRowData?.event_uuid)
      );
      setselectedVisit(findVisit);
    }
  }, [getPatientsDetailsData, editRowData, filteredVisit]);
  useEffect(() => {
    (async () => {
      if (filteredVisit?.id) {
        dispatch(showLoader());
        await getVisitSpecificCRFs({
          visit_id: filteredVisit?.id,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          visit_name: filteredVisit?.key,
          parent_id
        });
        dispatch(hideLoader());
      } else {
        dispatch(showLoader());
        const crfOIDsResponse: any = await getVisitsAndCRFOIDs({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry
        });
        if (crfOIDsResponse.isSuccess) {
          updateVisitCRFOIDs(crfOIDsResponse.data);
        } else {
          setvisitCRFOIDs([]);
          setselectedVisit(null);
          setcrfVisitList([]);
          setcrfFormMetaData(null);
        }
      }
      dispatch(hideLoader());
    })();
  }, [filteredVisit]);

  const editAddedRecord = (editAddedRecord: any) => {
    seteditRowData(editAddedRecord);
    setisUpdate(true);
    dispatch(openCRFModel(true));
  };
  const [bookMarkKey, setbookMarkKey] = useState<any>(null);
  const [bookMarkField, setbookMarkField] = useState<any>(null);
  const dateOfEntryConversion = (row: any) => {
    return row?.date_of_entry ? moment(row.date_of_entry).format(`${userPreferedDateFormat.toUpperCase()}`) : null;
  };
  useEffect(() => {
    if (crfFormMetaData && crfFormMetaData.meta?.sections) {
      const formData = crfFormMetaData.meta.sections.flatMap((section: any) =>
        section.rows.flatMap((row: any) => row.fields)
      );
      const find = formData?.find((item: any) => item?.bookmark);
      if (find) {
        setbookMarkKey(find.key);
        setbookMarkField(find);
      }
      const preparedColums: any = [
        {
          field: 'date_of_entry',
          type: 'string',
          headerName: 'Date Of Entry',
          minWidth: 100,
          flex: 1,
          renderCell: (params: any) => {
            if (params?.row && !('event_number' in params.row)) {
              return <span className="noParent" />;
            } else if (params?.row?.event_status !== 'Deleted') {
              return (
                <Link
                  onClick={async () => {
                    dispatch(showLoader());
                    await selectCRFDataByID({
                      data: {
                        OID: selectedFormOID,
                        patient_id: parent_id,
                        event_uuid: params.row.event_uuid,
                        visit_id: selectedVisit?.study_visit.id,
                        creation_source: params.row?.creation_source ? params.row?.creation_source : 'TSDA'
                      },
                      site_id: selectedSite,
                      study_id: studyId,
                      country: selectedCountry
                    });
                    editAddedRecord(params.row);
                    dispatch(hideLoader());
                  }}
                >
                  {dateOfEntryConversion(params?.row)}
                </Link>
              );
            } else {
              return <span className="deletedCRFEventRow">{dateOfEntryConversion(params?.row)}</span>;
            }
          },
          valueGetter: (params: any) => {
            if (params?.row && !('event_number' in params.row)) {
              return;
            } else {
              return dateOfEntryConversion(params?.row);
            }
          }
        },
        {
          field: 'event_status',
          type: 'singleSelect',
          headerName: 'Event Status',
          minWidth: 100,
          flex: 1,
          valueOptions: ['Draft', 'Complete', 'Deleted']
        }
      ];

      formData?.map((field: any) => {
        if (field?.key) {
          preparedColums.push({
            field: field?.key,
            type: 'string',
            headerName: field?.title,
            minWidth: 100,
            flex: 1
          });
        }
      });
      preparedColums.push({
        field: 'associated_crfs',
        type: 'string',
        headerName: 'Associated CRFs',
        minWidth: 130,
        flex: 1,
        renderCell: (params: any) => {
          return (
            <Stack direction="column" spacing={0.5}>
              {params?.row?.associated_crfs && params?.row?.associated_crfs.length > 0
                ? params?.row?.associated_crfs?.map((linkedCrf: any) => {
                    return (
                      <Chip
                        key={linkedCrf}
                        size="small"
                        label={linkedCrf}
                        variant="outlined"
                        color="primary"
                        sx={{ fontSize: '12px', fontWeight: 700 }}
                      />
                    );
                  })
                : null}
            </Stack>
          );
        }
      });
      preparedColums.push({
        field: 'actions',
        type: 'actions',
        width: 80,
        getActions: (params: any) => {
          if (params?.row && 'event_number' in params.row && !checkPermission('delete_crf_event')) {
            return [
              <GridActionsCellItem
                disabled
                key={params?.row?.id}
                label="Delete"
                //onClick={() => deleteCRFEvent(params.row)}
                showInMenu
              />,
              <GridActionsCellItem
                key={params?.row?.id}
                label="Audit Trail"
                onClick={() => handleClickOpenAuditTrailCRF(params)}
                showInMenu
              />
            ];
          } else {
            return [];
          }
        }
      });
      setcrfForomColumns(preparedColums);
    }
  }, [crfFormMetaData]);

  // Audit Trail Dialog
  const [openAuditTrailCRF, setopenAuditTrailCRF] = useState(false);

  useGetAuditQuery({
    id: 'd310b560-11b1-4768-878f-9adf29d79c18',
    only_update: false,
    site_id: selectedSite || '',
    study_id: studyId || '',
    country: selectedCountry || '',
    application: process.env.REACT_APP_NAME,
    application_section: 'CONDUCT',
    application_module_section: 'CRFENTRY'
  });

  const handleClickOpenAuditTrailCRF = (crf: any) => {
    setRowData({ ...crf });
    setopenAuditTrailCRF(true);
    // audit();
  };
  // Audit Trail Dialog call ends
  const [auditUsersList, setAuditUsersList] = useState([]);
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();
  useEffect(() => {
    getAssignees({
      client_name: 'ctms-ui',
      data: ['VIEW_CRF_QUERIES', 'RAISE_CRF_QUERY', 'RESPOND_QUERY_CRF']
    });
  }, []);
  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = assignees?.map((item: any) => `${item.first_name} ${item.last_name}`);
      setAuditUsersList(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);
  const dataTableProps = {
    treeData: true,
    getTreeDataPath,
    getRowHeight: () => 'auto',
    getEstimatedRowHeight: () => 200,
    groupingColDef,
    onRowClick: (e: any) => {
      setSelectedRowData(e);
    },
    defaultGroupingExpansionDepth: 1,
    sx: {
      '& .MuiDataGrid-columnHeaderTitle': {
        // textOverflow: 'clip',
        whiteSpace: 'break-spaces',
        lineHeight: 1.3
      },
      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' }
    },
    localeText: { footerTotalRows: 'Total Row(s):' }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Conduct CRF Summary ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  useEffect(() => {
    (async () => {
      dispatch(showLoader());
      selectCRFDataByID({
        data: {
          OID: selectedVisit?.visit_crf.OID,
          patient_id: parent_id,
          event_uuid: editRowData?.event_uuid,
          visit_id: selectedVisit?.study_visit.id,
          creation_source: editRowData?.creation_source ? editRowData?.creation_source : 'TSDA'
        },
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
      dispatch(hideLoader());
    })();
  }, [editRowData?.event_uuid]);

  return (
    <div>
      <Box
        sx={{
          '@media (max-width:1367px)': {
            maxWidth: '960px'
          },
          '@media (min-width:1440px)': {
            maxWidth: '1000px'
          },
          '@media (min-width:1660px)': {
            maxWidth: '1360px'
          }
        }}
      >
        <TabContext value={selectedFormOID}>
          <TabList
            onChange={handleChangeOIDTabs}
            aria-label="Form OID Tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            className="mhTabs"
            sx={{ mt: 1, height: 36 }}
          >
            {visitCRFOIDs?.map((ele: any) => (
              <Tab
                iconPosition="end"
                style={{ height: '36px', minHeight: '36px' }}
                label={ele.custom_name ?? ele.OID}
                value={ele.OID}
                key={ele.OID}
              />
            ))}
          </TabList>
          {visitCRFOIDs?.map((ele: any) => (
            <TabPanel value={ele.OID} key={ele.OID} sx={{ p: 0 }} />
          ))}
        </TabContext>
      </Box>

      {crfFormMetaData && (
        <Box sx={{ flexGrow: 1 }} mt={1}>
          <Grid container col-md-12>
            <Grid item col-md-6>
              <h3 style={{ margin: '0.5rem 0 1.5rem' }}>
                {crfFormMetaData?.custom_name ?? crfFormMetaData?.meta?.title}
              </h3>
            </Grid>
          </Grid>
        </Box>
      )}

      <Box sx={{ width: '100%' }} mt={1}>
        <DataTable
          dataTableProps={dataTableProps}
          rows={crfVisitList}
          hasDefinedColumns
          columns={crfForomColumns}
          disableSelectionOnClick
          hasDefinedDataGridToolbarExport
          definedGridToolbarExport={definedCustomDatGridExport}
          height={'68vh'}
          pagination={false}
        />
      </Box>

      <CRFBasePopup
        selectedCRFFormCode={selectedFormOID}
        crfFormMetaData={crfFormMetaData}
        parent_id={parent_id}
        subject_id={subject_id}
        isUpdate={isUpdate}
        setisUpdate={setisUpdate}
        selectedVisit={selectedVisit}
        visitsData={getPatientsDetailsData}
        editRowData={editRowData}
        setselectedVisit={setselectedVisit}
        seteditRowData={seteditRowData}
        bookMarkKey={bookMarkKey}
        bookMarkField={bookMarkField}
        eventDataLoading={selectCRFDataByIDIsLoading}
      />
      {/* <Dialog maxWidth="lg" open={openAuditTrailCRF} onClose={handleCloseAuditTrailCRF}> */}
      <PopupComponent
        open={openAuditTrailCRF}
        maxWidth="md"
        sx={{
          '& .audit-history-modal .MuiGrid-grid-md-8 h2': { mrginBottom: '-8px !important' },
          '& .audit-trail-list': { height: 'auto', minHeight: '180px', maxHeight: '50vh', marginBottom: '-8px' },
          '& .MuiPagination-root': { marginBottom: '-12px' }
        }}
      >
        <AuditTrailContent
          handleCloseAudit={() => setopenAuditTrailCRF(false)}
          auditUsersList={auditUsersList}
          audit_module_section={`CRFENTRY`}
          id={rowData?.row?.event_uuid}
          AdvancedFilterArray={staticData.AdvancedQueryFilter}
          isCRFForm
          formDetails={crfFormMetaData?.meta}
        />
      </PopupComponent>
    </div>
  );
};
export default CRFSTab;
